<template>
  <router-view/>
</template>
<script>
import { core } from './config/pluginInit'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters({
      currentLocale: 'Setting/currentLocale'
    })
  },
  created () {
    this.setLocale()
  },
  mounted () {
    core.mainIndex()
  },
  methods: {
    setLocale () {
      if (this.currentLocale !== this.$i18n.locale) {
        this.$i18n.locale = this.currentLocale
      }
    }
  }
}
</script>

<style>
/* Poppins is self-hosted (assets/fonts/poppins) instead of Google Fonts */
/* @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;900&display=swap'); */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src: url("./assets/fonts/poppins/poppins-100.woff2") format("woff2");
}
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 200;
  font-display: swap;
  src: url("./assets/fonts/poppins/poppins-200.woff2") format("woff2");
}
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url("./assets/fonts/poppins/poppins-300.woff2") format("woff2");
}
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url("./assets/fonts/poppins/poppins-400.woff2") format("woff2");
}
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url("./assets/fonts/poppins/poppins-500.woff2") format("woff2");
}
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url("./assets/fonts/poppins/poppins-600.woff2") format("woff2");
}
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url("./assets/fonts/poppins/poppins-700.woff2") format("woff2");
}
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url("./assets/fonts/poppins/poppins-900.woff2") format("woff2");
}
@font-face {
  font-family: "Kalpurush";
  src: local("Kalpurush"),
   url("./assets/fonts/Kalpurush.ttf") format("truetype");
}
/* @font-face {
  font-family: "Nikosh";
  src: local("Nikosh"),
   url("./assets/fonts/Nikosh.ttf") format("truetype");
} */
</style>
<style lang="scss">
  @import "assets/scss/style.scss";
</style>
